import { BASE_URL } from '../../../../../utils/config.base-url'

export const CREATE_DEPT_PROJECT_PERMISSION_PREFIX_URL =
  '/create-dept-project-permission'
export const URL_ENDPOINT_CREATE_DEPT_PROJECT_PERMISSION = `${BASE_URL}/create-dept-project-permission`
